{
    "name": "Lovage",
    "binomial_name": "Levisticum officinale",
    "common_names": [
        "Lovage"
    ],
    "description": "Lovage is a perennial herb that tastes like an intensified cross between celery and parsley with a hint of anise. A member of Apiaceae family, it is related to carrots and celery. The leaves, roots, and young stems are edible. Leaves and hollow, thick stems can be added to salads, soups, and poultry dishes. The seeds can be used as a spice similar to fennel seeds. Lovage is also used as a companion crop because it's flowers attract beneficial insects like bees, hoverflies, lacewing larva, lady beetles, and parasitic wasps. Leaves can be harvested the first year, whole stems the second year.",
    "sun_requirements": "Partial Sun",
    "sowing_method": "Direct seed (indoors in early spring, outdoors in late spring or fall)",
    "spread": 80,
    "row_spacing": 60,
    "height": 180,
    "growing_degree_days": 90,
    "companions": [],
    "image": "/crops/images/lovage.jpg",
    "icon": "/crops/icons/lovage.avif"
}